export const COMPONENT_MAP = {
  bespoke_block: "be-spoke",
  rte_block: "rte",
  eclub_block: "eclub",
  enterprise_cards_block: 'enterprise-cards',
  enterprise_faq_block: 'faqs',
};

export const BRAND_CONTENT_TYPE = {
  default: 'generic_page',
  olivegarden: 'enterprise_generic_page'
}

export const API_REF = {
  API_REF_CONSTANT_GENERIC_PAGE: [
    "modular_blocks.bespoke_block_ref.reference",
    "modular_blocks.banner_block.reference.heading_image",
    "modular_blocks.banner_block.reference.image",
    "modular_blocks.banner_block.reference.links",
    "modular_blocks.banner_block.reference.links.internal_page",
    "modular_blocks.banner_block.reference",
    "modular_blocks.banner_block.reference.video",
    "modular_blocks.banner_block.reference.banner",
    "modular_blocks.cards_block.reference.link",
    "modular_blocks.cards_block.reference.cards.image",
    "modular_blocks.cards_block.reference.cards.heading_image",
    "modular_blocks.cards_block.reference.cards.link.internal_page",
    "modular_blocks.cards_block.reference.cards.sub_link",
    "modular_blocks.cards_block.reference.cards.sub_card.image",
    "modular_blocks.cards_block.reference.cards.sub_card.link",
    "modular_blocks.rte_block.reference.rte",
    "modular_blocks.eclub_block.reference.link",
    "modular_blocks.eclub_block.reference.image",
    "modular_blocks.eclub_block.reference.additional_links",
    "modular_blocks.enterprise_cards_block.reference.enterprise_cards",
    "modular_blocks.enterprise_cards_block.reference.enterprise_card",
    "modular_blocks.enterprise_cards_block.reference.cards.image",
    "modular_blocks.enterprise_cards_block.reference.cards.link",
    "modular_blocks.enterprise_cards_block.reference.cards.social_media_icons.icon",
    "modular_blocks.enterprise_cards_block.reference.cards.social_media_icons.link",
    "modular_blocks.enterprise_cards_block.reference.links",
    "modular_blocks.enterprise_banner_block.reference.enterprise_banner",
    "modular_blocks.enterprise_banner_block.reference.video",
    "modular_blocks.enterprise_banner_block.reference.links",
    "modular_blocks.enterprise_banner_block.reference.background_image",
    "modular_blocks.enterprise_banner_block.reference.carousel",
    "modular_blocks.enterprise_faq_block.reference.enterprise_faq",
    "modular_blocks.enterprise_faq_block.reference.list.enterprise_faq_item",
    "seo",
  ],
  GLOBAL_HEADER_FOOTER_REF: [
    "header.additional_navigation",
    "header.additional_navigation_description",
    "header.left_navigation.internal_page",
    "header.right_navigation",
    "header.mobile_navigation",
    "header.cart_group.cart_logo",
    "header.cart_group.links",
    "header.cart_group.links.internal_page",
    "header.location_links",
    "header.location_links.internal_page",
    "header.logo",
    "header.mobile_change_location_link.link",
    "header.mobile_location_links.link",
    "header.mobile_select_location_link.link",
    "header.reserve_link",
    "header.reserve_logo",
    "footer.footer_rows.links.internal_page",
    "footer.footer_rows.icons",
    "footer.footer_rows.icons.icon",
    "footer.footer_rows.icons.link",
    "footer.footer_mobile_links",
    "footer.footer_columns.links.internal_page",
    "footer.footer_columns.icons.icon",
    "footer.footer_columns.icons.link",
    "reserve_table",
    "eclub.link",
    "eclub.image",
    "header.cart_group.cart_logo",
    "eclub.cards",
    "eclub.cards.image",
    "eclub.cards.link",
    "eclub.cards.sub_link",
  ],
  GENERIC_SETTINGS_KEY: "global_settings",
};

export const FIELD_REFERENCE_MAP = {
  genericPage: [
    "modular_blocks.bespoke_block_ref.reference",
    "modular_blocks.banner_block.reference.heading_image",
    "modular_blocks.banner_block.reference.image",
    "modular_blocks.banner_block.reference.links",
    "modular_blocks.banner_block.reference.banner",
    "modular_blocks.banner_block.reference.link",
    "modular_blocks.cards_block.reference.cards.image",
    "modular_blocks.cards_block.reference.cards.link",
  ],
  globalSettings: [
    "header.additional_navigation",
    "header.left_navigation.internal_page",
    "header.right_navigation",
    "header.mobile_navigation",
    "header.cart_logo",
    "header.logo",
    "footer.footer_rows.links.internal_page",
    "reserve_table",
    "eclub.link",
  ],
};
export const LIVE_PREVIEW_SETTINGS = {
  mode: "builder",
  enable: true,
  ssr: true,
  enableLivePreview: true,
  editButtonEnable: false,
  editButtonExclude: ["outsideLivePreviewPortal"],
  editButtonIncludeByQueryParameter: false,
  editButtonPosition: "top-right",
  editInVisualBuilderButtonEnable: false,
};
